import {
  IBoxCreate,
  IBoxRole,
  IUserInviteCreate,
} from '@app/store/modules/boxes/types';
import { IBusinessBoxFieldsSettings } from './components/BusinessBoxCreate/types';
import { ProfileFields } from '@app/const/consts';

export const BUSINESS_BOX_INITIAL_VALUES: IBoxCreate = {
  email: '',
  companyName: '',
  companyZip: null,
  companyAddress: null,
  position: null,
};

export const BUSINESS_BOX_FIELDS: IBusinessBoxFieldsSettings[] = [
  {
    fieldName: ProfileFields.EMAIL,
    label: 'profile:fieldLabel:email',
    wrapperClasses: 'grid-item-8',
    required: true,
  },
  {
    fieldName: ProfileFields.COMPANY_NAME,
    label: 'profile:fieldLabel:nameCompany',
    wrapperClasses: 'grid-item-8',
    required: true,
  },
  {
    fieldName: ProfileFields.COMPANY_ZIP,
    label: 'profile:fieldLabel:postcode',
    wrapperClasses: 'grid-item-8',
  },
  {
    fieldName: ProfileFields.COMPANY_ADDRES,
    label: 'profile:fieldLabel:organizationAddress',
    wrapperClasses: 'grid-item-8',
  },
  {
    fieldName: ProfileFields.POSITION,
    label: 'profile:fieldLabel:position',
    wrapperClasses: 'grid-item-8',
  },
];

export const INVITE_USER_INITIAL_VALUES: IUserInviteCreate = {
  lastName: null,
  firstName: null,
  middleName: null,
  fullName: '',
  initials: null,
  email: null,
  position: null,
  locale: '',
  timeZone: '',
  role: IBoxRole.VIEWER,
  phone: null,
};

export const INVITE_USER_FIELDS: IBusinessBoxFieldsSettings[] = [
  {
    fieldName: ProfileFields.LAST_NAME,
    label: 'profile:fieldLabel:lastName',
    wrapperClasses: 'grid-item-8',
    required: true,
  },
  {
    fieldName: ProfileFields.FIRST_NAME,
    label: 'profile:fieldLabel:firstName',
    wrapperClasses: 'grid-item-8',
    required: true,
  },
  {
    fieldName: ProfileFields.MIDDLE_NAME,
    label: 'profile:fieldLabel:middleName',
    wrapperClasses: 'grid-item-8',
  },
  {
    fieldName: ProfileFields.FULL_NAME,
    label: 'profile:fieldLabel:fullName',
    wrapperClasses: 'grid-item-8',
  },
  {
    fieldName: ProfileFields.INITIALS,
    label: 'profile:fieldLabel:initials',
    wrapperClasses: 'grid-item-8',
  },
  {
    fieldName: ProfileFields.EMAIL,
    label: 'profile:fieldLabel:email',
    wrapperClasses: 'grid-item-8',
  },
  {
    fieldName: ProfileFields.POSITION,
    label: 'profile:fieldLabel:position',
    wrapperClasses: 'grid-item-8',
  },
  {
    fieldName: ProfileFields.LOCALE,
    label: 'profile:fieldLabel:locale',
    wrapperClasses: 'grid-item-8',
  },
  {
    fieldName: ProfileFields.TIME_ZONE,
    label: 'profile:fieldLabel:timeZone',
    wrapperClasses: 'grid-item-8',
  },
];
